export default __webpack_public_path__ + "static/media/OscilloscopesImg.970dcafb.jpg";